import PeopleOutlined from '@mui/icons-material/PeopleOutlined';
import { IAbsenteeismRateItem } from '../../../interfaces/IAbsenteeismRate';
import { AbsenteeismRateCard } from './AbsenteeismRateCard';

export const RankGenderWithMoreMedicalCertificate = ({ data }: { data: IAbsenteeismRateItem[] }) => (
  <AbsenteeismRateCard
    icon={<PeopleOutlined />}
    title="Taxa de absenteísmo por gênero"
    subtitle="Colaboradores com atestado sobre o total de colaboradores do gênero"
    data={data}
  />
);
